// Workspace colours are tenant-wide; the sidebar persists across light and dark modes.
// Text colours adapt automatically to the chosen background / sidebar / header.
const L_FG = "40 33% 96%";    // light text (for dark surfaces)
const L_MUT = "40 18% 80%";
const D_FG = "212 30% 14%";   // dark text (for light surfaces)
const D_MUT = "214 14% 40%";

export const THEME_PRESETS = {
  accent: [
    { id: "universal", name: "Universal", hsl: "165 62% 34%", dot: "#0F766E" },
    { id: "gold", name: "Gold", hsl: "44 76% 48%", dot: "#D4A017" },
    { id: "amber", name: "Amber", hsl: "38 92% 50%", dot: "#F59E0B" },
    { id: "orange", name: "Sunset Orange (Default)", hsl: "24 94% 53%", dot: "#F97316" },
    { id: "red", name: "Crimson", hsl: "0 72% 51%", dot: "#DC2626" },
    { id: "magenta", name: "Magenta", hsl: "330 75% 55%", dot: "#EC4899" },
    { id: "purple", name: "Violet", hsl: "270 60% 58%", dot: "#8B5CF6" },
    { id: "blue", name: "Royal Blue", hsl: "221 75% 53%", dot: "#2563EB" },
    { id: "cyan", name: "Cyan", hsl: "190 80% 42%", dot: "#06B6D4" },
    { id: "teal", name: "Teal", hsl: "174 62% 37%", dot: "#0F766E" },
    { id: "green", name: "Emerald", hsl: "152 60% 40%", dot: "#10B981" },
    { id: "lime", name: "Lime", hsl: "84 60% 42%", dot: "#84CC16" },
    { id: "slate", name: "Slate", hsl: "215 25% 45%", dot: "#475569" },
  ],
  background: [
    { id: "universal_light", name: "Universal Light", bg: "158 30% 96%", fg: D_FG, muted: D_MUT, dot: "#F4FAF6" },
    { id: "parchment", name: "Parchment (Default)", bg: "44 30% 96%", fg: D_FG, muted: D_MUT, dot: "#F6F3EC" },
    { id: "white", name: "Pure White", bg: "0 0% 100%", fg: D_FG, muted: D_MUT, dot: "#FFFFFF" },
    { id: "ivory", name: "Ivory", bg: "48 40% 97%", fg: D_FG, muted: D_MUT, dot: "#FBF8EF" },
    { id: "teal_mist", name: "Teal Mist", bg: "170 30% 96%", fg: D_FG, muted: D_MUT, dot: "#E6F4F1" },
    { id: "blush", name: "Blush", bg: "350 45% 97%", fg: D_FG, muted: D_MUT, dot: "#FBE9EC" },
    { id: "sky", name: "Sky", bg: "210 50% 97%", fg: D_FG, muted: D_MUT, dot: "#E8F1FB" },
    { id: "sage", name: "Sage", bg: "120 20% 96%", fg: D_FG, muted: D_MUT, dot: "#E9F1E8" },
    { id: "lavender", name: "Lavender", bg: "265 40% 97%", fg: D_FG, muted: D_MUT, dot: "#EFEAFB" },
    { id: "sand", name: "Warm Sand", bg: "36 40% 95%", fg: D_FG, muted: D_MUT, dot: "#F4ECDC" },
    { id: "cool_grey", name: "Cool Grey", bg: "215 18% 96%", fg: D_FG, muted: D_MUT, dot: "#EEF1F4" },
    { id: "graphite", name: "Graphite (dark)", bg: "220 18% 20%", fg: L_FG, muted: L_MUT, dot: "#2A313B" },
    { id: "midnight_teal", name: "Midnight Teal (dark)", bg: "185 40% 16%", fg: L_FG, muted: L_MUT, dot: "#10302E" },
  ],
  sidebar: [
    { id: "universal", name: "Universal", color: "#123D35", fg: L_FG, muted: L_MUT, dot: "#123D35" },
    { id: "default", name: "Default", color: "", fg: "", muted: "", dot: "#FCFAF4" },
    { id: "ivory", name: "Ivory", color: "#FBFAF6", fg: D_FG, muted: D_MUT, dot: "#FBFAF6" },
    { id: "blush", name: "Blush Rose", color: "#FBE9EC", fg: D_FG, muted: D_MUT, dot: "#FBE9EC" },
    { id: "teal_mist", name: "Teal Mist", color: "#E3F2EF", fg: D_FG, muted: D_MUT, dot: "#E3F2EF" },
    { id: "sky", name: "Sky", color: "#E6F0FB", fg: D_FG, muted: D_MUT, dot: "#E6F0FB" },
    { id: "sand", name: "Sand", color: "#F3ECDA", fg: D_FG, muted: D_MUT, dot: "#F3ECDA" },
    { id: "sage", name: "Sage", color: "#E8F0E6", fg: D_FG, muted: D_MUT, dot: "#E8F0E6" },
    { id: "lavender", name: "Lavender", color: "#EDE9FB", fg: D_FG, muted: D_MUT, dot: "#EDE9FB" },
    { id: "slate", name: "Slate (semi)", color: "#64748B", fg: L_FG, muted: L_MUT, dot: "#64748B" },
    { id: "teal", name: "Teal (semi)", color: "#2F7E74", fg: L_FG, muted: L_MUT, dot: "#2F7E74" },
    { id: "plum", name: "Plum (semi)", color: "#6D5A7E", fg: L_FG, muted: L_MUT, dot: "#6D5A7E" },
    { id: "indigo", name: "Indigo (semi)", color: "#4F5D95", fg: L_FG, muted: L_MUT, dot: "#4F5D95" },
    { id: "charcoal", name: "Charcoal", color: "#2B3647", fg: L_FG, muted: L_MUT, dot: "#2B3647" },
  ],
  topbar: [
    { id: "universal", name: "Universal Signature", color: "#0F766E", fg: L_FG, muted: L_MUT, dot: "#0F766E" },
    { id: "default", name: "Default", color: "", fg: "", muted: "", dot: "#FCFAF4" },
    { id: "ivory", name: "Ivory", color: "#FBFAF6", fg: D_FG, muted: D_MUT, dot: "#FBFAF6" },
    { id: "teal_mist", name: "Teal Mist", color: "#E3F2EF", fg: D_FG, muted: D_MUT, dot: "#E3F2EF" },
    { id: "sand", name: "Sand", color: "#F3ECDA", fg: D_FG, muted: D_MUT, dot: "#F3ECDA" },
    { id: "teal", name: "Teal Signature", color: "#0F766E", fg: L_FG, muted: L_MUT, dot: "#0F766E" },
    { id: "ochre", name: "Ochre", color: "#C8902A", fg: D_FG, muted: D_MUT, dot: "#C8902A" },
    { id: "royal", name: "Royal Blue", color: "#2E53B8", fg: L_FG, muted: L_MUT, dot: "#2E53B8" },
    { id: "plum", name: "Plum", color: "#6D5A7E", fg: L_FG, muted: L_MUT, dot: "#6D5A7E" },
    { id: "slate", name: "Slate", color: "#4A5A70", fg: L_FG, muted: L_MUT, dot: "#4A5A70" },
    { id: "emerald", name: "Emerald", color: "#2F8F6B", fg: L_FG, muted: L_MUT, dot: "#2F8F6B" },
  ],
  tableHeader: [
    { id: "universal", name: "Universal Gold", color: "#A77E2A", fg: "#FFFFFF", dot: "#A77E2A" },
    { id: "default", name: "Default", color: "", fg: "", dot: "#E9E4D6" },
    { id: "antique_gold", name: "Antique Gold", color: "#9A7B2E", fg: "#FFFFFF", dot: "#9A7B2E" },
    { id: "slate", name: "Slate", color: "#334155", fg: "#FFFFFF", dot: "#334155" },
    { id: "teal", name: "Teal", color: "#0F766E", fg: "#FFFFFF", dot: "#0F766E" },
    { id: "royal", name: "Royal Blue", color: "#2E53B8", fg: "#FFFFFF", dot: "#2E53B8" },
    { id: "soft_ochre", name: "Soft Ochre", color: "#F0E6CC", fg: "#3B2F0B", dot: "#F0E6CC" },
    { id: "blush", name: "Blush", color: "#F6D9DF", fg: "#5A2A34", dot: "#F6D9DF" },
    { id: "sage", name: "Sage", color: "#DCEBD6", fg: "#223018", dot: "#DCEBD6" },
  ],
  fontFamily: [
    { id: "inter", name: "Inter (Default)", stack: '"Inter", ui-sans-serif, system-ui, sans-serif' },
    { id: "roboto", name: "Roboto — Compact", stack: '"Roboto", system-ui, sans-serif', link: "https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap" },
    { id: "georgia", name: "Georgia — Serif", stack: 'Georgia, "Times New Roman", serif' },
    { id: "system", name: "System UI", stack: 'system-ui, -apple-system, "Segoe UI", sans-serif' },
  ],
};

export const FONT_SIZES = [
  { pct: 80, label: "80% — Compact" },
  { pct: 82.5, label: "82.5%" },
  { pct: 85, label: "85% — Default" },
  { pct: 90, label: "90%" },
  { pct: 100, label: "100% — Comfortable" },
  { pct: 110, label: "110% — Large" },
];

export const DEFAULT_THEME = {
  accent: "universal", background: "universal_light", sidebar: "universal",
  topbar: "universal", tableHeader: "universal", fontFamily: "roboto", fontSizePct: 85,
};

const LEGACY_THEME_IDS = {
  accent: { microfinance: "universal" },
  background: { microfinance_light: "universal_light" },
  sidebar: { microfinance: "universal" },
  topbar: { microfinance: "universal" },
  tableHeader: { microfinance: "universal" },
};

export function normalizeWorkspaceTheme(theme) {
  if (!theme || typeof theme !== "object" || Array.isArray(theme)) {
    return { ...DEFAULT_THEME };
  }

  const normalized = { ...DEFAULT_THEME, ...theme };
  Object.entries(LEGACY_THEME_IDS).forEach(([category, aliases]) => {
    normalized[category] = aliases[normalized[category]] || normalized[category];
  });
  if (!THEME_PRESETS.sidebar.some((preset) => preset.id === normalized.sidebar)) {
    normalized.sidebar = DEFAULT_THEME.sidebar;
  }
  if (!THEME_PRESETS.background.some((preset) => preset.id === normalized.background)) {
    normalized.background = DEFAULT_THEME.background;
  }
  if (!THEME_PRESETS.accent.some((preset) => preset.id === normalized.accent)) {
    normalized.accent = DEFAULT_THEME.accent;
  }
  if (!THEME_PRESETS.topbar.some((preset) => preset.id === normalized.topbar)) {
    normalized.topbar = DEFAULT_THEME.topbar;
  }
  if (!THEME_PRESETS.tableHeader.some((preset) => preset.id === normalized.tableHeader)) {
    normalized.tableHeader = DEFAULT_THEME.tableHeader;
  }
  if (!THEME_PRESETS.fontFamily.some((preset) => preset.id === normalized.fontFamily)) {
    normalized.fontFamily = DEFAULT_THEME.fontFamily;
  }
  return normalized;
}

export function presetOf(cat, id) {
  return THEME_PRESETS[cat].find((p) => p.id === id) || THEME_PRESETS[cat][0];
}

export function applyWorkspaceTheme(theme, mode) {
  const root = document.documentElement;
  const vars = [
    "--accent", "--ring", "--background", "--foreground", "--muted-foreground",
    "--ws-sidebar", "--ws-sidebar-fg", "--ws-sidebar-muted",
    "--ws-topbar", "--ws-topbar-fg", "--ws-topbar-muted",
    "--ws-table-header", "--ws-table-header-fg",
  ];
  vars.forEach((v) => root.style.removeProperty(v));
  root.style.fontSize = "";
  document.body.style.fontFamily = "";

  const t = normalizeWorkspaceTheme(theme);
  root.classList.add("ws-active");

  const sb = presetOf("sidebar", t.sidebar);
  if (sb.color) {
    root.style.setProperty("--ws-sidebar", sb.color);
    root.style.setProperty("--ws-sidebar-fg", sb.fg);
    root.style.setProperty("--ws-sidebar-muted", sb.muted);
  }

  if (mode !== "light") return;

  const acc = presetOf("accent", t.accent);
  root.style.setProperty("--accent", acc.hsl);
  root.style.setProperty("--ring", acc.hsl);

  const bg = presetOf("background", t.background);
  root.style.setProperty("--background", bg.bg);
  root.style.setProperty("--foreground", bg.fg);
  root.style.setProperty("--muted-foreground", bg.muted);

  const tb = presetOf("topbar", t.topbar);
  if (tb.color) {
    root.style.setProperty("--ws-topbar", tb.color);
    root.style.setProperty("--ws-topbar-fg", tb.fg);
    root.style.setProperty("--ws-topbar-muted", tb.muted);
  }
  const th = presetOf("tableHeader", t.tableHeader);
  if (th.color) {
    root.style.setProperty("--ws-table-header", th.color);
    root.style.setProperty("--ws-table-header-fg", th.fg);
  }

  const ff = presetOf("fontFamily", t.fontFamily);
  if (ff.link && !document.getElementById("ws-font-link")) {
    const l = document.createElement("link");
    l.id = "ws-font-link"; l.rel = "stylesheet"; l.href = ff.link;
    document.head.appendChild(l);
  }
  document.body.style.fontFamily = ff.stack;
  if (t.fontSizePct) root.style.fontSize = `${t.fontSizePct}%`;
}
